import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { xFindClosestIndex } from 'ml-spectra-processing';
import { useContext, useEffect, useMemo, useState } from 'react';
import { get1DDataXY } from '../../data/data1d/Spectrum1D/get1DDataXY';
import { MouseContext } from '../EventsTrackers/MouseTracker';
import { useChartData } from '../context/ChartContext';
import { useScale } from '../context/ScaleContext';
import Events from '../utility/Events';
const styles = {
    container: {
        position: 'absolute',
        left: '10px',
        top: '10px',
    },
    value: {
        width: '67px',
        display: 'inline-block',
        margin: '0 5px',
        fontSize: '12px',
    },
    colorIndicator: {
        width: '10px',
        height: '1px',
        borderBottom: `2px solid`,
        display: 'inline-block',
        marginBottom: '3px',
    },
    name: {
        fontSize: '12px',
    },
};
function YTracker({ datum }) {
    const { scaleX } = useScale();
    const position = useContext(MouseContext);
    if (!scaleX || !position) {
        return null;
    }
    const xIndex = xFindClosestIndex(datum.x, scaleX().invert(position.x));
    return _jsx("span", { style: styles.value, children: datum.y[xIndex] });
}
function SpectraTracker() {
    const { data, view: { spectra: { activeTab }, }, xDomains, } = useChartData();
    const [isVisible, toggleVisibility] = useState(false);
    useEffect(() => {
        function handler(flag) {
            toggleVisibility(flag);
        }
        Events.on('showYSpectraTrackers', handler);
        return () => {
            Events.off('showYSpectraTrackers', handler);
        };
    }, []);
    const trackers = useMemo(() => {
        return (isVisible &&
            data.map((spectrum) => spectrum.display.isVisible &&
                xDomains[spectrum.id] &&
                spectrum.info.nucleus === activeTab && (_jsxs("div", { style: { display: 'block' }, children: [_jsx("span", { style: {
                            ...styles.colorIndicator,
                            borderColor: spectrum.display.color,
                        } }), _jsx(YTracker, { datum: get1DDataXY(spectrum) }), _jsx("span", { style: styles.value, children: spectrum.display.name })] }, spectrum.id))));
    }, [activeTab, data, isVisible, xDomains]);
    if (!isVisible)
        return null;
    return _jsx("div", { style: styles.container, children: trackers });
}
export default SpectraTracker;
